import Button from "@/components/Button";
import { InputField } from "@/components/InputField";
import { useTranslation } from "@repo/shared/i18n";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { APIStatus } from "../../../../api/APIStatus.type";
import { shareSquad } from "../../../../api/privateRequests/squad-builder/share-squad";
import { copy } from "../../../../icons";
import { addAlert } from "../../../../redux/message/messageSlice";
import { AppDispatch } from "../../../../redux/store";

type ShareSquadSectionProps = {
  squadData?: any;
};

const ShareSquadSection = ({ squadData }: ShareSquadSectionProps) => {
  const { t } = useTranslation(["squadBuilder", "common"]);
  const dispatch = useDispatch<AppDispatch>();
  const [statusShareSquad, setStatusShareSquad] = useState<APIStatus>("idle");
  const [shareSquadUrl, setShareSquadUrl] = useState<string>("");

  useEffect(() => {
    if (!squadData) return;

    const generateShareSquadUrl = async () => {
      try {
        const res = await shareSquad(squadData);
        setShareSquadUrl(window.location.href + "?id=" + res.id);
        setStatusShareSquad("fulfilled");
      } catch {
        setStatusShareSquad("rejected");
      }
    };
    setStatusShareSquad("pending");
    generateShareSquadUrl();
  }, [squadData]);

  const handleCopy = () => {
    if (shareSquadUrl) {
      navigator.clipboard.writeText(shareSquadUrl).then(
        () => {
          dispatch(
            addAlert({
              title: t("shareSquad.copiedTitle"),
              description: t("shareSquad.copiedBody"),
              type: "success",
            }),
          );
        },
        (err) => {
          console.error("Failed to copy: ", err);
        },
      );
    }
  };

  return (
    <div className="flex flex-col mb-2 mt-4 text-center items-center">
      {statusShareSquad === "rejected" ? (
        <p className="text-dark-secondary text-sm">{t("shareSquad.failed")}</p>
      ) : (
        <div className="flex flex-row gap-x-2">
          <InputField
            value={shareSquadUrl}
            placeholder={t("shareSquad.generatingLink")}
            onChange={() => {}}
            dismissSearch={() => {}}
            type={"default"}
            readOnly={true}
          />

          <Button
            onClick={handleCopy}
            variant={"primary"}
            label={t("common:copy")}
            icon={copy}
          />
        </div>
      )}
    </div>
  );
};

export default ShareSquadSection;
